module.exports = __webpack_public_path__ + "img/mn.24ca7a0f.svg";